module.exports = __webpack_public_path__ + "static/media/skype.c41f51ff.svg";